var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wh-2 rounded-half cursor-pointer",style:(_vm.style),on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }